import { Navigate, useLocation } from "react-router-dom";

const supportedLangs = ["en", "ru", "ar", "pt", "es", "fr", "ko"];

function LanguageRedirect() {
  const location = useLocation();

  const browserLang = navigator.language.slice(0, 2);

  const lang = supportedLangs.includes(browserLang)
    ? browserLang
    : "en";

  const pathname = location.pathname;

  // already language exists
  const firstSegment = pathname.split("/")[1];

  if (supportedLangs.includes(firstSegment)) {
    return <Navigate to={pathname} replace />;
  }

  return (
    <Navigate
      to={`/${lang}${pathname}${location.search}`}
      replace
    />
  );
}

export default LanguageRedirect;